export const apiPath = '/v2/containers';
const actionType = 'CONTAINER_CONTROLS';

export const bulkActionType = `${actionType}_BULK`;

export default actionType;
